import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const GROUP_TYPES = {
  default: {
    title: Text.H5,
    titleColor: Colors.gray600,
    meta: Text.BodySmall,
    metaColor: Colors.gray500
  },
  article: {
    title: Text.H4,
    titleColor: Colors.gray500,
    meta: Text.BodySmall,
    metaColor: Colors.gray400
  },
  form: {
    title: Text.BodyBase,
    titleColor: Colors.gray600
  },
  details: {
    title: Text.BodyExtraSmall,
    titleColor: Colors.gray400
  },
  'mobile-app-details': {
    title: Text.BodyExtraSmall,
    titleColor: Colors.gray400
  }
};
const styles = {
  default: {
    textAlign: 'center'
  },
  details: {
    height: '20px',
    display: 'flex',
    alignItems: 'center'
  },
  'mobile-app-details': {
    height: '18px',
    display: 'flex',
    alignItems: 'center'
  },
  'mobile-app-padding': {
    paddingTop: 28,
    paddingBottom: 12,
    paddingLeft: 24
  }
};
export default function HeadingGroup(props) {
  const groupType = GROUP_TYPES[props.type];
  const TitleText = groupType.title;
  const MetaText = groupType.meta;
  return /*#__PURE__*/React.createElement(View, {
    style: props.type === 'mobile-app-details' && styles['mobile-app-padding']
  }, /*#__PURE__*/React.createElement(TitleText, {
    color: groupType.titleColor,
    weight: "medium",
    style: styles[props.type]
  }, props.title), MetaText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(MetaText, {
    color: groupType.metaColor,
    style: props.type === 'default' && styles.default
  }, props.children)));
}
HeadingGroup.propTypes = {
  type: PropTypes.oneOf(Object.keys(GROUP_TYPES)),
  title: PropTypes.string,
  children: PropTypes.string
};
HeadingGroup.defaultProps = {
  type: 'default',
  title: '',
  children: ''
};
//# sourceMappingURL=index.js.map